import React, { useState } from 'react';
import { Box, Paper, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SettingsMenu from './components/SettingsMenu';
import UserSettings from './sections/UserSettings';
import PreferencesSettings from './sections/PreferencesSettings';
import DevicesSettings from './sections/DevicesSettings';
import GroupsSettings from './sections/GroupsSettings';
import DriversSettings from './sections/DriversSettings';
import GeofencesSettings from './sections/GeofencesSettings';
import NotificationsSettings from './sections/NotificationsSettings';
import CalendarsSettings from './sections/CalendarsSettings';
import UsersSettings from './sections/UsersSettings';
import ServerSettings from './sections/ServerSettings';
import StatisticsSettings from './sections/StatisticsSettings';
import AttributesSettings from './sections/AttributesSettings';

const SettingsLayout = ({ onClose }) => {
  const [selectedSection, setSelectedSection] = useState('devices');

  const sections = {
    user: { component: UserSettings, label: 'Usuario' },
    preferences: { component: PreferencesSettings, label: 'Preferencias' },
    devices: { component: DevicesSettings, label: 'Dispositivos' },
    groups: { component: GroupsSettings, label: 'Grupos' },
    drivers: { component: DriversSettings, label: 'Conductores' },
    geofences: { component: GeofencesSettings, label: 'Geocercas' },
    notifications: { component: NotificationsSettings, label: 'Notificaciones' },
    calendars: { component: CalendarsSettings, label: 'Calendarios' },
    users: { component: UsersSettings, label: 'Usuarios' },
    server: { component: ServerSettings, label: 'Servidor' },
    statistics: { component: StatisticsSettings, label: 'Estadísticas' },
    attributes: { component: AttributesSettings, label: 'Atributos' },
  };

  const CurrentComponent = sections[selectedSection]?.component || DevicesSettings;
  const currentLabel = sections[selectedSection]?.label || 'Ajustes';

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100vh',
        width: '100vw',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 2000,
        bgcolor: '#f5f5f5',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: 280,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 0,
          borderRight: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            p: 2,
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.1rem' }}>
            Ajustes
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        <SettingsMenu
          selectedSection={selectedSection}
          onSectionChange={setSelectedSection}
        />
      </Paper>
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <Box
          sx={{
            p: 3,
            borderBottom: '1px solid',
            borderColor: 'divider',
            bgcolor: 'white',
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 600 }}>
            {currentLabel}
          </Typography>
        </Box>
        <Box sx={{ flex: 1, overflow: 'auto', p: 3 }}>
          <CurrentComponent />
        </Box>
      </Box>
    </Box>
  );
};

export default SettingsLayout;
